<template>
  <main-sidebar :name="name" :title="$t('filters')">
    <div class="p-4">
        <vs-row vs-w="12" class="mb-2 mt-4">
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        >
          <label>{{ $t('vendor') }}</label>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        >
          <v-select 
          label="name" 
          :filterable="false" 
          :options="vendors" 
          @search="onSearchVendors"   
          v-model="filter.vendors" 
          class="w-full" 
          multiple  
          ></v-select>
        </vs-col>
      </vs-row>
      <vs-row class="mb-4">
        <vs-col>
          <label>{{ $t('companies') | capitalize }}</label>
        </vs-col>
      </vs-row>
      <vs-row class="mb-4">
        <vs-col>
          <v-select
            v-model="filter.companies"
            :options="companies"
            class="w-full"
            :reduce="(el) => el.company_id"
            label="company_name"
            multiple
          />
        </vs-col>
      </vs-row>
      <vs-row class="mb-4">
        <vs-col>
          <label>{{ $t('periods') | capitalize }}</label>
        </vs-col>
      </vs-row>
      <vs-row class="mb-4">
        <vs-col>
          <v-select
            v-model="filter.periods"
            :options="periods"
            class="w-full"
            :reduce="(el) => el.period_id"
            label="week_year"
            multiple
          />
        </vs-col>
      </vs-row>
      <vs-row class="mb-4">
        <vs-col>
          <label>{{ $t('currencies') | capitalize }}</label>
        </vs-col>
      </vs-row>
      <vs-row class="mb-4">
        <vs-col>
          <v-select
            v-model="filter.currencies"
            :options="currencies"
            class="w-full"
            :autoscroll="false"
            multiple
          />
        </vs-col>
      </vs-row>
      <vs-row class="mb-4">
        <vs-col>
          <input-date
            :label="$t('date') | capitalize"
            v-model="filter.date"
          />
        </vs-col>
      </vs-row>
    </div>
    <div class="mx-4" slot="footer">
      <vs-button color="primary" type="filled" class="mr-6" @click="setFilter">
        {{ $t('apply_filters') }}
      </vs-button>
      <vs-button color="primary" type="border" @click="clear">
        {{ $t('clear_filters') }}
      </vs-button>
    </div>
  </main-sidebar>
</template>

<script>
import MainSidebar from '@/views/components/MainSidebar.vue'
import vSelect from 'vue-select'
import loading from '@/mixins/Loading'
import InputDate from '@/components/custom/InputDate'
import request from '../request.js'
import debounce from 'lodash/debounce'
export default {
  components: {
    MainSidebar,
    'v-select': vSelect,
    InputDate,
  },
  computed: {
    isSidebarActive() {
      return this.$store.state.sidebar === this.name
    },
    isLoading() {
      return this.loading.vendors
    },
  },
  data: () => ({
    vendors: [],
    companies: [],
    periods: [],
    categories: [],
    currencies: [],
    currencies: ['MXN', 'USD'],
    filter: {
      vendors: [],
      companies: [],
      periods: [],
      categories: [],
      currencies: [],
      date:''
    },
    defaultFilters: {
      vendors: [],
      companies: [],
      periods: [],
      categories: [],
      currencies: [],
      date:''
    },
    loading: {
      vendors: false,
      companies: false,
      periods: false,
      categories: false,
      currencies: false,
    },
  }),
  methods: {
    clear() {
      this.filter = Object.assign({}, this.defaultFilters)
    },
    close() {
      this.$store.dispatch('toggleSidebar', '')
    },
    init() {
      this.filter = { ...this.value }
    },
    setFilter() {
      this.$emit('input', this.filter)
      this.$emit('search')
      this.close()
    },
    getCompanies() {
      request
        .getCompanies()
        .then((response) => {
          this.companies = [...response.data.companies]
        })
        .catch((response) => {
          this.$vs.notify({
            color: 'danger',
            title: 'Attention2',
            text: 'Server Error',
          })
        })
    },
   onSearchVendors(search, loading) {
      if(search.length > 3) {
        loading(true);
       this.getVendors(loading, search, this);
      }
    },
    getVendors:debounce((loading, search, vm) => {
      request
        .getVendors({search:search})
        .then((res) => {
          vm.vendors = [...res.data.vendors,...vm.filter.vendors]
          loading(false);
        })
        .catch((err) => {
          vm.vendors = []
          loading(false);
        })
      }),
    getPeriods() {
      request
        .getPeriods()
        .then((response) => {
          this.periods = [...response.data.periods]
        })
        .catch((response) => {
          this.$vs.notify({
            color: 'danger',
            title: 'Attention4',
            text: 'Server Error',
          })
        })
    },
  },
  mixins: [loading],
  props: {
    name: {
      type: String,
      required: true,
    },
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  watch: {
    isLoading(val) {
      if (val) {
        this.openLoading(`loading-${this.name}-sidebar`)
      } else {
        this.closeLoading(`loading-${this.name}-sidebar`)
      }
    },
  },
  mounted() {
    this.getCompanies()
    this.getPeriods()
  },
}
</script>

<style>
</style>
